/**
 * Shopify 自定义封装用于 Joy 积分展示与兑换
 */

// ==================== 客户积分获取封装 ====================
function myCustomGetJoyPointFn(callback) {
    const fetchPoints = () => {
        joyInstance.customer().then((resp) => {
            const point = resp?.point || 0;
            callback(point);
        }).catch((err) => {
            console.error("获取积分失败:", err);
            callback(0);
        });
    };

    if (window.joyInstance) {
        fetchPoints();
    } else {
        window.addEventListener('joy:ready', fetchPoints);
    }
}

// ==================== 页面加载时处理 ====================
// function loadMyNewData() {
//     const clickMobElement = () => {
//         setTimeout(() => {
//             $(".account-mypoint-show-point-content-mob").click();
//         }, 1000);
//     };

//     getJoyCustomerPoints((points_balance) => {
//         renderPoints(points_balance);
//         clickMobElement();
//     });
// }

// ==================== 封装兑换逻辑 ====================
function MyCustomJoyRedeemCoupon(params={codeKey: codeKey,points: points}, callback) {
    const runRedeem = () => {
        joyInstance.customer().then((resp) => {
            if (resp?.state === 'enabled') {
                joyInstance.redeem(params.codeKey).then((result) => {
                    const code = result?.discount?.code;
                    if (code) {
                        callback('success',{code:code});
                    } else {
                        callback('noCode',{});
                    }
                }).catch((err) => {
                    callback('codeFailed',err);

                });
            } else {
                onDisabled();
                callback('customerDisabled',{});
            }
        }).catch((err) => {
            console.error("客户信息获取失败:", err);
            // onFailure(err);
            callback('customerFailed',err);
        });
    };

    if (window.joyInstance) {
        runRedeem();
    } else {
        window.addEventListener('joy:ready', runRedeem);
    }
}

// ==================== 可导出全局函数（按需调用） ====================
// window.loadMyNewData = loadMyNewData;
// window.beforeRedeemCoupon = beforeRedeemCoupon;